/**
 * 堺出土品マップアプリ用コード
 *
 * @type {IHSakaiArtifact}
 */
module.exports = class IHOsakaSueki extends IH{
  constructor(options) {
    super(options);
    this.options = options;
    this.mapOptions.type = 'googlemap';
    this.mapOptions.gmap_options_default.zoom = 12;
    this.mapOptions.gmap_options_default.minZoom = 12;
    this.mapOptions.gmap_options_default.maxZoom = 19;
    this.mapOptions.setMarkerMargin = true;
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: '器種',
      searchApi: 'search',
      mappingItems: {
        lat: '緯度',
        lng: '経度',
        image: '画像',
        image_label: 'image_label',
        name: '名称',
        address: '',
        description: '',
        info: 'info'
      },
      sortTarget: {
        kana: '50音',
        era: '時代'
      },
      sortValue: {
        eras: {
          '5世紀初め': 1,
          '5世紀前半': 2,
          '5世紀中頃': 3,
          '5世紀後半': 4,
          '6世紀後半': 5,
          '7世紀前半': 6,
          '7世紀中頃〜7世紀後半': 7,
          '5世紀〜9世紀': 8,
          '不明': 999,
        }
      },
      //firstSelection: '須恵器'
    };
    this.defaultSortKey = 'kana';
    this.defaultSortOrder = 1;
    this.sortKey_1 = 'kana';
    this.sortOrder_1 = 1;
    this.sortKey_2 = 'era';
    this.sortOrder_2 = 1;
    this.detailMenus = ['よみがな', '用途', '時代', '出土場所（詳細）', '文化財種別', '所有・管理'];
    this.searchTargetTypes = [];
    this.show_direction_on_marker_click = false;
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    let that = this;
    
    $(that).on('ready', () => {
      // GPS現在地連動モードに移行
      $('.js-user-location').on('click', function(){
        let elm = $(this);
        
        that.shiftToLocationMode().then(function(){
          elm.closest('.ui-popup').popup('close');
        });
        
        return false;
      });
      
      // 詳細パネルとマーカーポップアップの内容の書き換え
      $(that).on('ihFillMarkerPopup', function(event, place, popup) {
        // 詳細パネル: アプリ固有の項目を作成する
        that.createDetailMenus(place, popup);
        
        // 詳細パネル: 画像ポップアップを作成する
        that.createImagePopup(place, popup);
  
        // マーカポップアップに出土場所を表示する
        let markerInfo = '出土場所: ' + place.attributes['出土場所'];
        popup.find('.iw-desc').text(markerInfo);
      });
      
      $(that).on('ihFillSearchResult', function(event, place, item) {
        let text = place.attributes['よみがな'];
        item.find('.sr-info').text(text);
        item.find('.sr-type').hide();
      });
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      let attr = this.detailMenus[i];
      let text = '';
      
      // 施設オブジェクトに項目名と同じプロパティがあり、プロパティ値が空で無ければ項目の内容として表示
      if (attr in place.attributes && place.attributes[attr] !== '') {
        text = place.attributes[attr];
        
        if ( attr === '出土場所（詳細）' ) {
          attr = '出土場所';
        }
        
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').find('.iw-label').text(attr);
        popup.find('.iw-facet-' + (i+1)).html(text);
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').show();
      } else {
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    if ( place.image && popup.find('.iw-image-popup').length ){
      let imagePaths = place.image.split('|');                   // 画像パス ( 複数指定の場合、区切り文字は '|' )
      let imageTitles = place.attributes['名称'].split('|');  // 画像名称 ( 複数指定の場合、区切り文字は '|' )
      let numOfImages = imagePaths.length;                       // 画像枚数
      
      // 画像パスを整形
      for(let i = 0; i < numOfImages; i++) {
        // 改行や空白を削除
        imagePaths[i] = imagePaths[i].replace(/[\n\r\s]/g, '');
        
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!imagePaths[i].match(/^http/)) {
          imagePaths[i] = this.place_image_path + imagePaths[i];
        }
      }
      
      // 画像名称を整形
      for(let i = 0, len = imageTitles.length; i < len; i++) {
        // 改行や空白を削除
        imageTitles[i] = imageTitles[i].replace(/[\n\r\s]/g, '');
      }
      
      // 画像枚数が2枚以上なら、ポップアップボタンの下に枚数表示
      if(numOfImages > 1){
        $('.iw-image-count').each(function () {
          $(this).text(numOfImages + '枚');
        });
      } else {
        $('.iw-image-count').each(function () {
          $(this).text('');
        });
      }
      
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        //var imagePopupClose = $('<a href="#" data-rel="back" data-role="button" data-theme="a" class="ui-btn-right ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-notext ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text">Close</span><span class="ui-icon ui-icon-delete ui-icon-shadow">&nbsp;</span></span></a>').appendTo( imagePopup);
        //var img = $('<img>').appendTo( imagePopup );
        
        imagePopup.popup();
        
        // ポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">閉じる</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
        
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      }
      
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
      
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
      
      // img要素のtitle属性（スライダのキャプションに利用される）
      let title = '';
      
      // img要素を作成し、スライダー用divに追加
      for(let i = 0; i < numOfImages; i++) {
        // title属性に画像名称を設定
        if(imageTitles[i]) {
          // 「（名称なし）」なら替わりに遺跡名を表示
          if( imageTitles[i] === '（名称なし）' ) {
            title = '（' + place.name + '）';
          } else {
            title = imageTitles[i];
          }
          // 画像名称が空欄なら替わりに遺跡名を表示
        } else {
          title = '（' + place.name + '）';
        }
        
        // 画像は1枚目のみ読み込み、他はスライド直前に読み込み（遅延ロード）
        // 遅延ロードさせないと、ポップアップウィンドウ表示時に画像が一瞬縦に並んでしまう
        if (i === 0) {
          $('<div class="sliding-images"><img src="' + imagePaths[i] + '" title="' + title + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        } else {
          $('<div class="sliding-images"><img title="' + title + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        }
      }
      
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          onSlideBefore: function($slideElement, oldIndex, newIndex){
            $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
          }
        });
      });
    }else{
      popup.find('.iw-image-popup').hide();
    }
    
    if (place.image_label && popup.find('.iw-image-label').length){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').text(place.image_label);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes(){
    let types = [];
    for (let i in this.searchTargetTypes){
      if (this.searchTargetTypes[i]){
        types.push(i);
      }
    }
    return types;
  }
};


// WEBPACK FOOTER //
// ./map/js/ih/extend/IHOsakaSueki.js